"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit");

function Duration(_ref) {
  var duration = _ref.duration,
      onChangeAddon = _ref.onChangeAddon,
      DURATIONS = _ref.DURATIONS,
      disabled = _ref.disabled;
  return _react["default"].createElement(_uiKit.Dropdown, {
    options: DURATIONS,
    defaultValue: DURATIONS && DURATIONS.find(function (durationOption) {
      return durationOption.value === duration;
    }),
    label: "DURATION",
    onChange: onChangeAddon("DURATION"),
    fontSize: 12,
    hideSeparators: !0,
    showSelectedSuffix: !0,
    disabled: disabled
  });
}

var _default = (0, _react.memo)(Duration);

exports["default"] = _default;